import BaseCrudService from '@/services/base-crud-service'
import userConfig from '@/config/user-config'

class UsersService extends BaseCrudService {}

export default new UsersService(userConfig.API_RESOURCE)
